import { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { when } from '../../lib/n4';
import { Markdown } from './Markdown';

// Pluginok: újrahasználható kiegészítők a projektekhez. Rövid leírás (ezt látják az ügynökök), teljes leírás csak kinyitva, fejlesztői útmutató.
interface Change { version: string; note: string; tested?: string; modifies?: string; limits?: string; from?: string; at?: number }
interface Plugin { slug: string; title: string; version: string; short: string; when: string; target?: { label?: string; detect?: string[] }; changelog: Change[]; docsChars: number; installs: { project: string; project_id: number; version: string; installed_at: number }[] }

export function PluginsSection() {
  const [items, setItems] = useState<Plugin[]>([]);
  const [guide, setGuide] = useState('');
  const [showGuide, setShowGuide] = useState(false);
  const [open, setOpen] = useState<string | null>(null);
  const [docs, setDocs] = useState<Record<string, string>>({});
  useEffect(() => { void api<{ plugins: Plugin[]; guide: string }>('/api/n4/plugins').then((r) => { setItems(r.plugins); setGuide(r.guide); }).catch(() => {}); }, []);
  const toggle = (slug: string) => {
    const next = open === slug ? null : slug; setOpen(next);
    if (next && docs[next] == null) void api<{ docs: string }>(`/api/n4/plugins/${next}`).then((r) => setDocs((d) => ({ ...d, [next]: r.docs }))).catch(() => {});
  };
  return (
    <section className="a-panel a-pad">
      <div className="a-ph"><h3 className="text-neutral-100">Pluginok</h3><span className="a-meta">{items.length} plugin</span></div>
      <p className="a-sub" style={{ marginTop: -6, marginBottom: 12 }}>Újrahasználható kiegészítők a projektekhez. A projekthez illők rövid leírását minden ügynök látja; a teljes leírást akkor kapja meg, ha használja (n4_plugin get). Telepítés és frissítés: n4_plugin install, az adott projekt ügynöke végzi.</p>
      <div className="a-guide">
        <button className="a-guide-btn" onClick={() => setShowGuide(!showGuide)} aria-expanded={showGuide}>{showGuide ? '▾' : '▸'} Útmutató plugin fejlesztéséhez</button>
        {showGuide && <pre className="a-guide-txt">{guide}</pre>}
      </div>
      {items.length === 0 && <p className="a-sub">Még nincs plugin. Egy ügynök az útmutató alapján készíti el, és n4_plugin publish-sel adja ki.</p>}
      <div className="a-sugg-list a-stagger">
        {items.map((p, i) => {
          const isOpen = open === p.slug;
          return (
            <article key={p.slug} className="a-sugg st-kesz a-plugin" style={{ ['--i' as string]: i }}>
              <button className="a-sugg-head" onClick={() => toggle(p.slug)} aria-expanded={isOpen}>
                <span className="votes" style={{ fontSize: 13 }}>{p.version}</span>
                <span className="min-w-0 flex-1">
                  <b>{p.title}</b>
                  <span className="who">{p.short}</span>
                  <span className="who">Cél: <em>{p.target?.label ?? '—'}</em> · Telepítve: {p.installs.length ? p.installs.map((x) => `${x.project} ${x.version}`).join(', ') : 'még sehol'}</span>
                </span>
                <span className="st st-elfogadva">{p.slug}</span>
              </button>
              {isOpen && (
                <div className="a-sugg-body">
                  <p className="txt"><b className="text-neutral-200">Mikor:</b> {p.when}</p>
                  <div className="a-compl" style={{ background: 'rgba(255,255,255,.02)', borderColor: 'var(--color-term-border)' }}>
                    <dt>Felismerés</dt><dd>{(p.target?.detect || []).join(', ') || '—'}</dd>
                    <dt>Változások</dt><dd>{[...p.changelog].reverse().map((c) => `${c.version}: ${c.note}${c.from ? ` (${c.from}${c.at ? `, ${when(c.at)}` : ''})` : ''}`).join('\n')}</dd>
                  </div>
                  <div className="a-plugin-docs">{docs[p.slug] == null ? <p className="a-sub">Leírás betöltése…</p> : <Markdown text={docs[p.slug] ?? ""} />}</div>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}
